import React from 'react'
import style from './index.module.less'
import { Link } from "gatsby"
import useNavigateLink from "@/hooks/useNavigateLink";
import { useIntl } from 'react-intl';
import getCountry from '@/utils/getCountry.js'
import { REGION_TO_FOOTER_MAP } from '@/data/newfooter.js'

const FooterList = () => {
    const intl = useIntl()
    const region = getCountry()
    const navigateLink = useNavigateLink;
    const footer_list_arr = REGION_TO_FOOTER_MAP[region] || REGION_TO_FOOTER_MAP.default
    
    const getLinkUrl = (link) => {
        const url = navigateLink(link)
        return url
    }

    return (
        <div className={style.footerList}>
            {
                footer_list_arr.map((item, index) => (
                    <div className={style.footerListItem} key={item.title}>
                        <div className={style.footerListItemTitle}>
                            {intl.formatMessage({ id: item.title })}

                        </div>
                        <div className={style.footerListItemBox}>
                            {item.list.map((value) => (
                                <div className={style.footerListItemBoxValue} key={value.name}
                                >
                                    {
                                        value.outlink ? 
                                        <a href={value.link} target='_blank'>
                                            {value.translate ? intl.formatMessage({ id: value.name }) : value.name} 
                                        </a> : <Link to={getLinkUrl(value.link)}>
                                            {value.translate ? intl.formatMessage({ id: value.name }) : value.name}
                                        </Link>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default FooterList